import React from 'react';
import PropTypes from 'prop-types';

import styled, { withTheme } from 'styled-components';
import { white, black } from '../../../../theme/theme/colors';
import { Layout, Box, Text } from '../../../Boneyard';

const StadiumBannerContainer = styled(Box)`
  background: ${black};
  color: ${white};
`;

const AllegiantStadiumLogo = styled.img.attrs(props => ({
  src: props.logo?.path,
  alt: props.logo?.alt,
}))`
  height: 35px;
  margin-right: ${props => props.theme.spacing(2)};
`;

const StadiumBanner = ({ image, label, showStadiumBanner, automationHook }) => {
  return (
    <StadiumBannerContainer automationHook={automationHook}>
      <Layout.Strip>
        {showStadiumBanner && (
          <Box pt={2} pb={2} d="flex" alignItems="center">
            <AllegiantStadiumLogo logo={image} />
            <Text size={14} weight={500}>
              {label}
            </Text>
          </Box>
        )}
      </Layout.Strip>
    </StadiumBannerContainer>
  );
};

StadiumBanner.propTypes = {
  image: PropTypes.object,
  label: PropTypes.string,
  theme: PropTypes.object,
  showStadiumBanner: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  automationHook: PropTypes.string,
};

export default withTheme(StadiumBanner);
